export default __webpack_public_path__ + "12eeced3c27c28cc0537b67055937253.svg";